var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackGroundOfSectionTwo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1777,
    viewBox: "0 0 1920 1777",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 0L194.077 89.0568L105.02 178.114L66.8455 139.939L79.5705 127.214L105.02 152.664L168.627 89.0568L92.2955 12.725L105.02 0Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 25.4319L92.2954 38.1569L41.4136 89.0569L66.8454 114.507L54.1386 127.214L15.9636 89.0569L79.5704 25.4319Z",
    fill: "#00A44F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 0L395.368 89.0568L306.312 178.114L268.155 139.939L280.862 127.214L306.312 152.664L369.918 89.0568L293.587 12.725L306.312 0Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 25.4319L293.587 38.1569L242.705 89.0569L268.155 114.507L255.43 127.214L217.255 89.0569L280.862 25.4319Z",
    fill: "#00A44F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 0L596.66 89.0568L507.603 178.114L469.446 139.939L482.171 127.214L507.603 152.664L571.228 89.0568L494.878 12.725L507.603 0Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 25.4319L494.896 38.1569L443.996 89.0569L469.446 114.507L456.721 127.214L418.546 89.0569L482.171 25.4319Z",
    fill: "#00A44F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 0L797.969 89.0568L708.913 178.114L670.738 139.939L683.463 127.214L708.894 152.664L772.519 89.0568L696.188 12.725L708.913 0Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 25.4319L696.188 38.1569L645.288 89.0569L670.738 114.507L658.013 127.214L619.856 89.0569L683.463 25.4319Z",
    fill: "#00A44F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 0L999.261 89.0568L910.204 178.114L872.029 139.939L884.754 127.214L910.204 152.664L973.811 89.0568L897.479 12.725L910.204 0Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 25.4319L897.479 38.1569L846.579 89.0569L872.029 114.507L859.304 127.214L821.147 89.0569L884.754 25.4319Z",
    fill: "#00A44F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 0L1200.55 89.0568L1111.5 178.114L1073.32 139.939L1086.05 127.214L1111.5 152.664L1175.1 89.0568L1098.77 12.725L1111.5 0Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 25.4319L1098.77 38.1569L1047.89 89.0569L1073.32 114.507L1060.61 127.214L1022.44 89.0569L1086.05 25.4319Z",
    fill: "#00A44F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 0L1401.84 89.0568L1312.79 178.114L1274.63 139.939L1287.34 127.214L1312.79 152.664L1376.39 89.0568L1300.06 12.725L1312.79 0Z",
    fill: "#231F20"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 25.4319L1300.06 38.1569L1249.18 89.0569L1274.63 114.507L1261.9 127.214L1223.73 89.0569L1287.34 25.4319Z",
    fill: "#00A44F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 0L1603.13 89.0568L1514.08 178.114L1475.92 139.939L1488.65 127.214L1514.08 152.664L1577.7 89.0568L1501.35 12.725L1514.08 0Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 25.4319L1501.37 38.1569L1450.47 89.0569L1475.92 114.507L1463.2 127.214L1425.02 89.0569L1488.65 25.4319Z",
    fill: "#00A44F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 0L1804.44 89.0568L1715.39 178.114L1677.21 139.939L1689.94 127.214L1715.39 152.664L1778.99 89.0568L1702.66 12.725L1715.39 0Z",
    fill: "#231F20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 25.4319L1702.66 38.1569L1651.76 89.0569L1677.21 114.507L1664.49 127.214L1626.33 89.0569L1689.94 25.4319Z",
    fill: "#00A44F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 0L2005.74 89.0568L1916.68 178.114L1878.5 139.939L1891.23 127.214L1916.68 152.664L1980.29 89.0568L1903.95 12.725L1916.68 0Z",
    fill: "#231F20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 25.4319L1903.95 38.1569L1853.05 89.0569L1878.5 114.507L1865.78 127.214L1827.62 89.0569L1891.23 25.4319Z",
    fill: "#00A44F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 107.181L92.1135 196.238L3.05672 285.295L-35.1001 247.12L-22.3751 234.395L3.05672 259.845L66.6817 196.238L-9.6501 119.906L3.05672 107.181Z",
    fill: "#231F20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 107.181L293.423 196.238L204.366 285.295L166.191 247.12L178.916 234.395L204.366 259.845L267.973 196.238L191.641 119.906L204.366 107.181Z",
    fill: "#231F20"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 132.631L191.641 145.338L140.741 196.238L166.191 221.688L153.466 234.395L115.31 196.238L178.916 132.631Z",
    fill: "#00A44F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 107.181L494.714 196.238L405.658 285.295L367.483 247.12L380.208 234.395L405.658 259.845L469.264 196.238L392.933 119.906L405.658 107.181Z",
    fill: "#231F20"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 132.631L392.933 145.338L342.051 196.238L367.483 221.688L354.758 234.395L316.601 196.238L380.208 132.631Z",
    fill: "#00A44F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 107.181L696.006 196.238L606.949 285.295L568.774 247.12L581.499 234.395L606.949 259.845L670.556 196.238L594.224 119.906L606.949 107.181Z",
    fill: "#231F20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 132.631L594.224 145.338L543.342 196.238L568.774 221.688L556.067 234.395L517.892 196.238L581.499 132.631Z",
    fill: "#00A44F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 107.181L897.297 196.238L808.241 285.295L770.084 247.12L782.791 234.395L808.241 259.845L871.847 196.238L795.516 119.906L808.241 107.181Z",
    fill: "#231F20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 132.631L795.515 145.338L744.634 196.238L770.084 221.688L757.359 234.395L719.184 196.238L782.809 132.631Z",
    fill: "#00A44F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 107.181L1098.61 196.238L1009.53 285.295L971.375 247.12L984.1 234.395L1009.53 259.845L1073.16 196.238L996.825 119.906L1009.53 107.181Z",
    fill: "#231F20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 132.631L996.825 145.338L945.925 196.238L971.375 221.688L958.65 234.395L920.475 196.238L984.1 132.631Z",
    fill: "#00A44F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 107.181L1299.9 196.238L1210.84 285.295L1172.67 247.12L1185.39 234.395L1210.84 259.845L1274.45 196.238L1198.12 119.906L1210.84 107.181Z",
    fill: "#231F20"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 132.631L1198.12 145.338L1147.22 196.238L1172.67 221.688L1159.94 234.395L1121.78 196.238L1185.39 132.631Z",
    fill: "#00A44F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 107.181L1501.19 196.238L1412.13 285.295L1373.96 247.12L1386.68 234.395L1412.13 259.845L1475.74 196.238L1399.41 119.906L1412.13 107.181Z",
    fill: "#231F20"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 132.631L1399.41 145.338L1348.53 196.238L1373.96 221.688L1361.23 234.395L1323.08 196.238L1386.68 132.631Z",
    fill: "#00A44F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 107.181L1702.48 196.238L1613.42 285.295L1575.25 247.12L1587.97 234.395L1613.42 259.845L1677.03 196.238L1600.7 119.906L1613.42 107.181Z",
    fill: "#231F20"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 132.631L1600.7 145.338L1549.82 196.238L1575.25 221.688L1562.54 234.395L1524.37 196.238L1587.97 132.631Z",
    fill: "#00A44F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 107.181L1903.77 196.238L1814.71 285.295L1776.56 247.12L1789.26 234.395L1814.71 259.845L1878.34 196.238L1801.99 119.906L1814.71 107.181Z",
    fill: "#231F20"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 132.631L1801.99 145.338L1751.11 196.238L1776.56 221.688L1763.83 234.395L1725.66 196.238L1789.28 132.631Z",
    fill: "#00A44F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 213.053L194.077 302.11L105.02 391.166L66.8455 353.01L79.5705 340.285L105.02 365.716L168.627 302.11L92.2955 225.778L105.02 213.053Z",
    fill: "#231F20"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 238.503L92.2954 251.228L41.4136 302.11L66.8454 327.56L54.1386 340.285L15.9636 302.11L79.5704 238.503Z",
    fill: "#00A44F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 213.053L395.368 302.11L306.312 391.166L268.155 353.01L280.862 340.285L306.312 365.716L369.918 302.11L293.587 225.778L306.312 213.053Z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 238.503L293.587 251.228L242.705 302.11L268.155 327.56L255.43 340.285L217.255 302.11L280.862 238.503Z",
    fill: "#00A44F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 213.053L596.66 302.11L507.603 391.166L469.446 353.01L482.171 340.285L507.603 365.716L571.228 302.11L494.878 225.778L507.603 213.053Z",
    fill: "#231F20"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 238.503L494.896 251.228L443.996 302.11L469.446 327.56L456.721 340.285L418.546 302.11L482.171 238.503Z",
    fill: "#00A44F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 213.053L797.969 302.11L708.913 391.166L670.738 353.01L683.463 340.285L708.894 365.716L772.519 302.11L696.188 225.778L708.913 213.053Z",
    fill: "#231F20"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 238.503L696.188 251.228L645.288 302.11L670.738 327.56L658.013 340.285L619.856 302.11L683.463 238.503Z",
    fill: "#00A44F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 213.053L999.261 302.11L910.204 391.166L872.029 353.01L884.754 340.285L910.204 365.716L973.811 302.11L897.479 225.778L910.204 213.053Z",
    fill: "#231F20"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 238.503L897.479 251.228L846.579 302.11L872.029 327.56L859.304 340.285L821.147 302.11L884.754 238.503Z",
    fill: "#00A44F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 213.053L1200.55 302.11L1111.5 391.166L1073.32 353.01L1086.05 340.285L1111.5 365.716L1175.1 302.11L1098.77 225.778L1111.5 213.053Z",
    fill: "#231F20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 238.503L1098.77 251.228L1047.89 302.11L1073.32 327.56L1060.61 340.285L1022.44 302.11L1086.05 238.503Z",
    fill: "#00A44F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 213.053L1401.84 302.11L1312.79 391.166L1274.63 353.01L1287.34 340.285L1312.79 365.716L1376.39 302.11L1300.06 225.778L1312.79 213.053Z",
    fill: "#231F20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 238.503L1300.06 251.228L1249.18 302.11L1274.63 327.56L1261.9 340.285L1223.73 302.11L1287.34 238.503Z",
    fill: "#00A44F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 213.053L1603.13 302.11L1514.08 391.166L1475.92 353.01L1488.65 340.285L1514.08 365.716L1577.7 302.11L1501.35 225.778L1514.08 213.053Z",
    fill: "#231F20"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 238.503L1501.37 251.228L1450.47 302.11L1475.92 327.56L1463.2 340.285L1425.02 302.11L1488.65 238.503Z",
    fill: "#00A44F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 213.053L1804.44 302.11L1715.39 391.166L1677.21 353.01L1689.94 340.285L1715.39 365.716L1778.99 302.11L1702.66 225.778L1715.39 213.053Z",
    fill: "#231F20"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 238.503L1702.66 251.228L1651.76 302.11L1677.21 327.56L1664.49 340.285L1626.33 302.11L1689.94 238.503Z",
    fill: "#00A44F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 213.053L2005.74 302.11L1916.68 391.166L1878.5 353.01L1891.23 340.285L1916.68 365.716L1980.29 302.11L1903.95 225.778L1916.68 213.053Z",
    fill: "#231F20"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 238.503L1903.95 251.228L1853.05 302.11L1878.5 327.56L1865.78 340.285L1827.62 302.11L1891.23 238.503Z",
    fill: "#00A44F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 320.234L92.1135 409.29L3.05672 498.347L-35.1001 460.19L-22.3751 447.465L3.05672 472.915L66.6817 409.29L-9.6501 332.959L3.05672 320.234Z",
    fill: "#231F20"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 320.234L293.423 409.29L204.366 498.347L166.191 460.19L178.916 447.465L204.366 472.915L267.973 409.29L191.641 332.959L204.366 320.234Z",
    fill: "#231F20"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 345.684L191.641 358.409L140.741 409.291L166.191 434.741L153.466 447.466L115.31 409.291L178.916 345.684Z",
    fill: "#00A44F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 320.234L494.714 409.29L405.658 498.347L367.483 460.19L380.208 447.465L405.658 472.915L469.264 409.29L392.933 332.959L405.658 320.234Z",
    fill: "#231F20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 345.684L392.933 358.409L342.051 409.291L367.483 434.741L354.758 447.466L316.601 409.291L380.208 345.684Z",
    fill: "#00A44F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 320.234L696.006 409.29L606.949 498.347L568.774 460.19L581.499 447.465L606.949 472.915L670.556 409.29L594.224 332.959L606.949 320.234Z",
    fill: "#231F20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 345.684L594.224 358.409L543.342 409.291L568.774 434.741L556.067 447.466L517.892 409.291L581.499 345.684Z",
    fill: "#00A44F"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 320.234L897.297 409.29L808.241 498.347L770.084 460.19L782.791 447.465L808.241 472.915L871.847 409.29L795.516 332.959L808.241 320.234Z",
    fill: "#231F20"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 345.684L795.515 358.409L744.634 409.291L770.084 434.741L757.359 447.466L719.184 409.291L782.809 345.684Z",
    fill: "#00A44F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 320.234L1098.61 409.29L1009.53 498.347L971.375 460.19L984.1 447.465L1009.53 472.915L1073.16 409.29L996.825 332.959L1009.53 320.234Z",
    fill: "#231F20"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 345.684L996.825 358.409L945.925 409.291L971.375 434.741L958.65 447.466L920.475 409.291L984.1 345.684Z",
    fill: "#00A44F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 320.234L1299.9 409.29L1210.84 498.347L1172.67 460.19L1185.39 447.465L1210.84 472.915L1274.45 409.29L1198.12 332.959L1210.84 320.234Z",
    fill: "#231F20"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 345.684L1198.12 358.409L1147.22 409.291L1172.67 434.741L1159.94 447.466L1121.78 409.291L1185.39 345.684Z",
    fill: "#00A44F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 320.234L1501.19 409.29L1412.13 498.347L1373.96 460.19L1386.68 447.465L1412.13 472.915L1475.74 409.29L1399.41 332.959L1412.13 320.234Z",
    fill: "#231F20"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 345.684L1399.41 358.409L1348.53 409.291L1373.96 434.741L1361.23 447.466L1323.08 409.291L1386.68 345.684Z",
    fill: "#00A44F"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 320.234L1702.48 409.29L1613.42 498.347L1575.25 460.19L1587.97 447.465L1613.42 472.915L1677.03 409.29L1600.7 332.959L1613.42 320.234Z",
    fill: "#231F20"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 345.684L1600.7 358.409L1549.82 409.291L1575.25 434.741L1562.54 447.466L1524.37 409.291L1587.97 345.684Z",
    fill: "#00A44F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 320.234L1903.77 409.29L1814.71 498.347L1776.56 460.19L1789.26 447.465L1814.71 472.915L1878.34 409.29L1801.99 332.959L1814.71 320.234Z",
    fill: "#231F20"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 345.684L1801.99 358.409L1751.11 409.291L1776.56 434.741L1763.83 447.466L1725.66 409.291L1789.28 345.684Z",
    fill: "#00A44F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 426.106L194.077 515.163L105.02 604.219L66.8455 566.063L79.5705 553.338L105.02 578.788L168.627 515.163L92.2955 438.831L105.02 426.106Z",
    fill: "#231F20"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 451.556L92.2954 464.281L41.4136 515.181L66.8454 540.612L54.1386 553.338L15.9636 515.162L79.5704 451.556Z",
    fill: "#00A44F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 426.106L395.368 515.163L306.312 604.219L268.155 566.063L280.862 553.338L306.312 578.788L369.918 515.163L293.587 438.831L306.312 426.106Z",
    fill: "#231F20"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 451.556L293.587 464.281L242.705 515.181L268.155 540.612L255.43 553.338L217.255 515.162L280.862 451.556Z",
    fill: "#00A44F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 426.106L596.66 515.163L507.603 604.219L469.446 566.063L482.171 553.338L507.603 578.788L571.228 515.163L494.878 438.831L507.603 426.106Z",
    fill: "#231F20"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 451.556L494.896 464.281L443.996 515.181L469.446 540.612L456.721 553.338L418.546 515.162L482.171 451.556Z",
    fill: "#00A44F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 426.106L797.969 515.163L708.913 604.219L670.738 566.063L683.463 553.338L708.894 578.788L772.519 515.163L696.188 438.831L708.913 426.106Z",
    fill: "#231F20"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 451.556L696.188 464.281L645.288 515.181L670.738 540.612L658.013 553.338L619.856 515.162L683.463 451.556Z",
    fill: "#00A44F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 426.106L999.261 515.163L910.204 604.219L872.029 566.063L884.754 553.338L910.204 578.788L973.811 515.163L897.479 438.831L910.204 426.106Z",
    fill: "#231F20"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 451.556L897.479 464.281L846.579 515.181L872.029 540.612L859.304 553.338L821.147 515.162L884.754 451.556Z",
    fill: "#00A44F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 426.106L1200.55 515.163L1111.5 604.219L1073.32 566.063L1086.05 553.338L1111.5 578.788L1175.1 515.163L1098.77 438.831L1111.5 426.106Z",
    fill: "#231F20"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 451.556L1098.77 464.281L1047.89 515.181L1073.32 540.612L1060.61 553.338L1022.44 515.162L1086.05 451.556Z",
    fill: "#00A44F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 426.106L1401.84 515.163L1312.79 604.219L1274.63 566.063L1287.34 553.338L1312.79 578.788L1376.39 515.163L1300.06 438.831L1312.79 426.106Z",
    fill: "#231F20"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 451.556L1300.06 464.281L1249.18 515.181L1274.63 540.612L1261.9 553.338L1223.73 515.162L1287.34 451.556Z",
    fill: "#00A44F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 426.106L1603.13 515.163L1514.08 604.219L1475.92 566.063L1488.65 553.338L1514.08 578.788L1577.7 515.163L1501.35 438.831L1514.08 426.106Z",
    fill: "#231F20"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 451.556L1501.37 464.281L1450.47 515.181L1475.92 540.612L1463.2 553.338L1425.02 515.162L1488.65 451.556Z",
    fill: "#00A44F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 426.106L1804.44 515.163L1715.39 604.219L1677.21 566.063L1689.94 553.338L1715.39 578.788L1778.99 515.163L1702.66 438.831L1715.39 426.106Z",
    fill: "#231F20"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 451.556L1702.66 464.281L1651.76 515.181L1677.21 540.612L1664.49 553.338L1626.33 515.162L1689.94 451.556Z",
    fill: "#00A44F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 426.106L2005.74 515.163L1916.68 604.219L1878.5 566.063L1891.23 553.338L1916.68 578.788L1980.29 515.163L1903.95 438.831L1916.68 426.106Z",
    fill: "#231F20"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 451.556L1903.95 464.281L1853.05 515.181L1878.5 540.612L1865.78 553.338L1827.62 515.162L1891.23 451.556Z",
    fill: "#00A44F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 533.305L92.1135 622.361L3.05672 711.418L-35.1001 673.243L-22.3751 660.518L3.05672 685.968L66.6817 622.361L-9.6501 546.011L3.05672 533.305Z",
    fill: "#231F20"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 533.305L293.423 622.361L204.366 711.418L166.191 673.243L178.916 660.518L204.366 685.968L267.973 622.361L191.641 546.011L204.366 533.305Z",
    fill: "#231F20"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 558.736L191.641 571.461L140.741 622.361L166.191 647.793L153.466 660.518L115.31 622.361L178.916 558.736Z",
    fill: "#00A44F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 533.305L494.714 622.361L405.658 711.418L367.483 673.243L380.208 660.518L405.658 685.968L469.264 622.361L392.933 546.011L405.658 533.305Z",
    fill: "#231F20"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 558.736L392.933 571.461L342.051 622.361L367.483 647.793L354.758 660.518L316.601 622.361L380.208 558.736Z",
    fill: "#00A44F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 533.305L696.006 622.361L606.949 711.418L568.774 673.243L581.499 660.518L606.949 685.968L670.556 622.361L594.224 546.011L606.949 533.305Z",
    fill: "#231F20"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 558.736L594.224 571.461L543.342 622.361L568.774 647.793L556.067 660.518L517.892 622.361L581.499 558.736Z",
    fill: "#00A44F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 533.305L897.297 622.361L808.241 711.418L770.084 673.243L782.791 660.518L808.241 685.968L871.847 622.361L795.516 546.011L808.241 533.305Z",
    fill: "#231F20"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 558.736L795.515 571.461L744.634 622.361L770.084 647.793L757.359 660.518L719.184 622.361L782.809 558.736Z",
    fill: "#00A44F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 533.305L1098.61 622.361L1009.53 711.418L971.375 673.243L984.1 660.518L1009.53 685.968L1073.16 622.361L996.825 546.011L1009.53 533.305Z",
    fill: "#231F20"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 558.736L996.825 571.461L945.925 622.361L971.375 647.793L958.65 660.518L920.475 622.361L984.1 558.736Z",
    fill: "#00A44F"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 533.305L1299.9 622.361L1210.84 711.418L1172.67 673.243L1185.39 660.518L1210.84 685.968L1274.45 622.361L1198.12 546.011L1210.84 533.305Z",
    fill: "#231F20"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 558.736L1198.12 571.461L1147.22 622.361L1172.67 647.793L1159.94 660.518L1121.78 622.361L1185.39 558.736Z",
    fill: "#00A44F"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 533.305L1501.19 622.361L1412.13 711.418L1373.96 673.243L1386.68 660.518L1412.13 685.968L1475.74 622.361L1399.41 546.011L1412.13 533.305Z",
    fill: "#231F20"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 558.736L1399.41 571.461L1348.53 622.361L1373.96 647.793L1361.23 660.518L1323.08 622.361L1386.68 558.736Z",
    fill: "#00A44F"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 533.305L1702.48 622.361L1613.42 711.418L1575.25 673.243L1587.97 660.518L1613.42 685.968L1677.03 622.361L1600.7 546.011L1613.42 533.305Z",
    fill: "#231F20"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 558.736L1600.7 571.461L1549.82 622.361L1575.25 647.793L1562.54 660.518L1524.37 622.361L1587.97 558.736Z",
    fill: "#00A44F"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 533.305L1903.77 622.361L1814.71 711.418L1776.56 673.243L1789.26 660.518L1814.71 685.968L1878.34 622.361L1801.99 546.011L1814.71 533.305Z",
    fill: "#231F20"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 558.736L1801.99 571.461L1751.11 622.361L1776.56 647.793L1763.83 660.518L1725.66 622.361L1789.28 558.736Z",
    fill: "#00A44F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 639.177L194.077 728.234L105.02 817.29L66.8455 779.115L79.5705 766.39L105.02 791.84L168.627 728.234L92.2955 651.902L105.02 639.177Z",
    fill: "#231F20"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 664.609L92.2954 677.334L41.4136 728.234L66.8454 753.684L54.1386 766.39L15.9636 728.234L79.5704 664.609Z",
    fill: "#00A44F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 639.177L395.368 728.234L306.312 817.29L268.155 779.115L280.862 766.39L306.312 791.84L369.918 728.234L293.587 651.902L306.312 639.177Z",
    fill: "#231F20"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 664.609L293.587 677.334L242.705 728.234L268.155 753.684L255.43 766.39L217.255 728.234L280.862 664.609Z",
    fill: "#00A44F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 639.177L596.66 728.234L507.603 817.29L469.446 779.115L482.171 766.39L507.603 791.84L571.228 728.234L494.878 651.902L507.603 639.177Z",
    fill: "#231F20"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 664.609L494.896 677.334L443.996 728.234L469.446 753.684L456.721 766.39L418.546 728.234L482.171 664.609Z",
    fill: "#00A44F"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 639.177L797.969 728.234L708.913 817.29L670.738 779.115L683.463 766.39L708.894 791.84L772.519 728.234L696.188 651.902L708.913 639.177Z",
    fill: "#231F20"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 664.609L696.188 677.334L645.288 728.234L670.738 753.684L658.013 766.39L619.856 728.234L683.463 664.609Z",
    fill: "#00A44F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 639.177L999.261 728.234L910.204 817.29L872.029 779.115L884.754 766.39L910.204 791.84L973.811 728.234L897.479 651.902L910.204 639.177Z",
    fill: "#231F20"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 664.609L897.479 677.334L846.579 728.234L872.029 753.684L859.304 766.39L821.147 728.234L884.754 664.609Z",
    fill: "#00A44F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 639.177L1200.55 728.234L1111.5 817.29L1073.32 779.115L1086.05 766.39L1111.5 791.84L1175.1 728.234L1098.77 651.902L1111.5 639.177Z",
    fill: "#231F20"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 664.609L1098.77 677.334L1047.89 728.234L1073.32 753.684L1060.61 766.39L1022.44 728.234L1086.05 664.609Z",
    fill: "#00A44F"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 639.177L1401.84 728.234L1312.79 817.29L1274.63 779.115L1287.34 766.39L1312.79 791.84L1376.39 728.234L1300.06 651.902L1312.79 639.177Z",
    fill: "#231F20"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 664.609L1300.06 677.334L1249.18 728.234L1274.63 753.684L1261.9 766.39L1223.73 728.234L1287.34 664.609Z",
    fill: "#00A44F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 639.177L1603.13 728.234L1514.08 817.29L1475.92 779.115L1488.65 766.39L1514.08 791.84L1577.7 728.234L1501.35 651.902L1514.08 639.177Z",
    fill: "#231F20"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 664.609L1501.37 677.334L1450.47 728.234L1475.92 753.684L1463.2 766.39L1425.02 728.234L1488.65 664.609Z",
    fill: "#00A44F"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 639.177L1804.44 728.234L1715.39 817.29L1677.21 779.115L1689.94 766.39L1715.39 791.84L1778.99 728.234L1702.66 651.902L1715.39 639.177Z",
    fill: "#231F20"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 664.609L1702.66 677.334L1651.76 728.234L1677.21 753.684L1664.49 766.39L1626.33 728.234L1689.94 664.609Z",
    fill: "#00A44F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 639.177L2005.74 728.234L1916.68 817.29L1878.5 779.115L1891.23 766.39L1916.68 791.84L1980.29 728.234L1903.95 651.902L1916.68 639.177Z",
    fill: "#231F20"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 664.609L1903.95 677.334L1853.05 728.234L1878.5 753.684L1865.78 766.39L1827.62 728.234L1891.23 664.609Z",
    fill: "#00A44F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 746.358L92.1135 835.414L3.05672 924.471L-35.1001 886.296L-22.3751 873.589L3.05672 899.021L66.6817 835.414L-9.6501 759.083L3.05672 746.358Z",
    fill: "#231F20"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 746.358L293.423 835.414L204.366 924.471L166.191 886.296L178.916 873.589L204.366 899.021L267.973 835.414L191.641 759.083L204.366 746.358Z",
    fill: "#231F20"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 771.808L191.641 784.514L140.741 835.414L166.191 860.864L153.466 873.589L115.31 835.414L178.916 771.808Z",
    fill: "#00A44F"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 746.358L494.714 835.414L405.658 924.471L367.483 886.296L380.208 873.589L405.658 899.021L469.264 835.414L392.933 759.083L405.658 746.358Z",
    fill: "#231F20"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 771.808L392.933 784.514L342.051 835.414L367.483 860.864L354.758 873.589L316.601 835.414L380.208 771.808Z",
    fill: "#00A44F"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 746.358L696.006 835.414L606.949 924.471L568.774 886.296L581.499 873.589L606.949 899.021L670.556 835.414L594.224 759.083L606.949 746.358Z",
    fill: "#231F20"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 771.808L594.224 784.514L543.342 835.414L568.774 860.864L556.067 873.589L517.892 835.414L581.499 771.808Z",
    fill: "#00A44F"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 746.358L897.297 835.414L808.241 924.471L770.084 886.296L782.791 873.589L808.241 899.021L871.847 835.414L795.516 759.083L808.241 746.358Z",
    fill: "#231F20"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 771.808L795.515 784.514L744.634 835.414L770.084 860.864L757.359 873.589L719.184 835.414L782.809 771.808Z",
    fill: "#00A44F"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 746.358L1098.61 835.414L1009.53 924.471L971.375 886.296L984.1 873.589L1009.53 899.021L1073.16 835.414L996.825 759.083L1009.53 746.358Z",
    fill: "#231F20"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 771.808L996.825 784.514L945.925 835.414L971.375 860.864L958.65 873.589L920.475 835.414L984.1 771.808Z",
    fill: "#00A44F"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 746.358L1299.9 835.414L1210.84 924.471L1172.67 886.296L1185.39 873.589L1210.84 899.021L1274.45 835.414L1198.12 759.083L1210.84 746.358Z",
    fill: "#231F20"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 771.808L1198.12 784.514L1147.22 835.414L1172.67 860.864L1159.94 873.589L1121.78 835.414L1185.39 771.808Z",
    fill: "#00A44F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 746.358L1501.19 835.414L1412.13 924.471L1373.96 886.296L1386.68 873.589L1412.13 899.021L1475.74 835.414L1399.41 759.083L1412.13 746.358Z",
    fill: "#231F20"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 771.808L1399.41 784.514L1348.53 835.414L1373.96 860.864L1361.23 873.589L1323.08 835.414L1386.68 771.808Z",
    fill: "#00A44F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 746.358L1702.48 835.414L1613.42 924.471L1575.25 886.296L1587.97 873.589L1613.42 899.021L1677.03 835.414L1600.7 759.083L1613.42 746.358Z",
    fill: "#231F20"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 771.808L1600.7 784.514L1549.82 835.414L1575.25 860.864L1562.54 873.589L1524.37 835.414L1587.97 771.808Z",
    fill: "#00A44F"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 746.358L1903.77 835.414L1814.71 924.471L1776.56 886.296L1789.26 873.589L1814.71 899.021L1878.34 835.414L1801.99 759.083L1814.71 746.358Z",
    fill: "#231F20"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 771.808L1801.99 784.514L1751.11 835.414L1776.56 860.864L1763.83 873.589L1725.66 835.414L1789.28 771.808Z",
    fill: "#00A44F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 852.23L194.077 941.286L105.02 1030.34L66.8455 992.186L79.5705 979.461L105.02 1004.89L168.627 941.286L92.2955 864.955L105.02 852.23Z",
    fill: "#231F20"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 877.68L92.2954 890.405L41.4136 941.286L66.8454 966.736L54.1386 979.461L15.9636 941.286L79.5704 877.68Z",
    fill: "#00A44F"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 852.23L395.368 941.286L306.312 1030.34L268.155 992.186L280.862 979.461L306.312 1004.89L369.918 941.286L293.587 864.955L306.312 852.23Z",
    fill: "#231F20"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 877.68L293.587 890.405L242.705 941.286L268.155 966.736L255.43 979.461L217.255 941.286L280.862 877.68Z",
    fill: "#00A44F"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 852.23L596.66 941.286L507.603 1030.34L469.446 992.186L482.171 979.461L507.603 1004.89L571.228 941.286L494.878 864.955L507.603 852.23Z",
    fill: "#231F20"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 877.68L494.896 890.405L443.996 941.286L469.446 966.736L456.721 979.461L418.546 941.286L482.171 877.68Z",
    fill: "#00A44F"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 852.23L797.969 941.286L708.913 1030.34L670.738 992.186L683.463 979.461L708.894 1004.89L772.519 941.286L696.188 864.955L708.913 852.23Z",
    fill: "#231F20"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 877.68L696.188 890.405L645.288 941.286L670.738 966.736L658.013 979.461L619.856 941.286L683.463 877.68Z",
    fill: "#00A44F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 852.23L999.261 941.286L910.204 1030.34L872.029 992.186L884.754 979.461L910.204 1004.89L973.811 941.286L897.479 864.955L910.204 852.23Z",
    fill: "#231F20"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 877.68L897.479 890.405L846.579 941.286L872.029 966.736L859.304 979.461L821.147 941.286L884.754 877.68Z",
    fill: "#00A44F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 852.23L1200.55 941.286L1111.5 1030.34L1073.32 992.186L1086.05 979.461L1111.5 1004.89L1175.1 941.286L1098.77 864.955L1111.5 852.23Z",
    fill: "#231F20"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 877.68L1098.77 890.405L1047.89 941.286L1073.32 966.736L1060.61 979.461L1022.44 941.286L1086.05 877.68Z",
    fill: "#00A44F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 852.23L1401.84 941.286L1312.79 1030.34L1274.63 992.186L1287.34 979.461L1312.79 1004.89L1376.39 941.286L1300.06 864.955L1312.79 852.23Z",
    fill: "#231F20"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 877.68L1300.06 890.405L1249.18 941.286L1274.63 966.736L1261.9 979.461L1223.73 941.286L1287.34 877.68Z",
    fill: "#00A44F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 852.23L1603.13 941.286L1514.08 1030.34L1475.92 992.186L1488.65 979.461L1514.08 1004.89L1577.7 941.286L1501.35 864.955L1514.08 852.23Z",
    fill: "#231F20"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 877.68L1501.37 890.405L1450.47 941.286L1475.92 966.736L1463.2 979.461L1425.02 941.286L1488.65 877.68Z",
    fill: "#00A44F"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 852.23L1804.44 941.286L1715.39 1030.34L1677.21 992.186L1689.94 979.461L1715.39 1004.89L1778.99 941.286L1702.66 864.955L1715.39 852.23Z",
    fill: "#231F20"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 877.68L1702.66 890.405L1651.76 941.286L1677.21 966.736L1664.49 979.461L1626.33 941.286L1689.94 877.68Z",
    fill: "#00A44F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 852.23L2005.74 941.286L1916.68 1030.34L1878.5 992.186L1891.23 979.461L1916.68 1004.89L1980.29 941.286L1903.95 864.955L1916.68 852.23Z",
    fill: "#231F20"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 877.68L1903.95 890.405L1853.05 941.286L1878.5 966.736L1865.78 979.461L1827.62 941.286L1891.23 877.68Z",
    fill: "#00A44F"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 959.41L92.1135 1048.47L3.05672 1137.52L-35.1001 1099.37L-22.3751 1086.64L3.05672 1112.09L66.6817 1048.47L-9.6501 972.135L3.05672 959.41Z",
    fill: "#231F20"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 959.41L293.423 1048.47L204.366 1137.52L166.191 1099.37L178.916 1086.64L204.366 1112.09L267.973 1048.47L191.641 972.135L204.366 959.41Z",
    fill: "#231F20"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 984.86L191.641 997.585L140.741 1048.47L166.191 1073.92L153.466 1086.64L115.31 1048.47L178.916 984.86Z",
    fill: "#00A44F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 959.41L494.714 1048.47L405.658 1137.52L367.483 1099.37L380.208 1086.64L405.658 1112.09L469.264 1048.47L392.933 972.135L405.658 959.41Z",
    fill: "#231F20"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 984.86L392.933 997.585L342.051 1048.47L367.483 1073.92L354.758 1086.64L316.601 1048.47L380.208 984.86Z",
    fill: "#00A44F"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 959.41L696.006 1048.47L606.949 1137.52L568.774 1099.37L581.499 1086.64L606.949 1112.09L670.556 1048.47L594.224 972.135L606.949 959.41Z",
    fill: "#231F20"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 984.86L594.224 997.585L543.342 1048.47L568.774 1073.92L556.067 1086.64L517.892 1048.47L581.499 984.86Z",
    fill: "#00A44F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 959.41L897.297 1048.47L808.241 1137.52L770.084 1099.37L782.791 1086.64L808.241 1112.09L871.847 1048.47L795.516 972.135L808.241 959.41Z",
    fill: "#231F20"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 984.86L795.515 997.585L744.634 1048.47L770.084 1073.92L757.359 1086.64L719.184 1048.47L782.809 984.86Z",
    fill: "#00A44F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 959.41L1098.61 1048.47L1009.53 1137.52L971.375 1099.37L984.1 1086.64L1009.53 1112.09L1073.16 1048.47L996.825 972.135L1009.53 959.41Z",
    fill: "#231F20"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 984.86L996.825 997.585L945.925 1048.47L971.375 1073.92L958.65 1086.64L920.475 1048.47L984.1 984.86Z",
    fill: "#00A44F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 959.41L1299.9 1048.47L1210.84 1137.52L1172.67 1099.37L1185.39 1086.64L1210.84 1112.09L1274.45 1048.47L1198.12 972.135L1210.84 959.41Z",
    fill: "#231F20"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 984.86L1198.12 997.585L1147.22 1048.47L1172.67 1073.92L1159.94 1086.64L1121.78 1048.47L1185.39 984.86Z",
    fill: "#00A44F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 959.41L1501.19 1048.47L1412.13 1137.52L1373.96 1099.37L1386.68 1086.64L1412.13 1112.09L1475.74 1048.47L1399.41 972.135L1412.13 959.41Z",
    fill: "#231F20"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 984.86L1399.41 997.585L1348.53 1048.47L1373.96 1073.92L1361.23 1086.64L1323.08 1048.47L1386.68 984.86Z",
    fill: "#00A44F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 959.41L1702.48 1048.47L1613.42 1137.52L1575.25 1099.37L1587.97 1086.64L1613.42 1112.09L1677.03 1048.47L1600.7 972.135L1613.42 959.41Z",
    fill: "#231F20"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 984.86L1600.7 997.585L1549.82 1048.47L1575.25 1073.92L1562.54 1086.64L1524.37 1048.47L1587.97 984.86Z",
    fill: "#00A44F"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 959.41L1903.77 1048.47L1814.71 1137.52L1776.56 1099.37L1789.26 1086.64L1814.71 1112.09L1878.34 1048.47L1801.99 972.135L1814.71 959.41Z",
    fill: "#231F20"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 984.86L1801.99 997.585L1751.11 1048.47L1776.56 1073.92L1763.83 1086.64L1725.66 1048.47L1789.28 984.86Z",
    fill: "#00A44F"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 1065.28L194.077 1154.34L105.02 1243.4L66.8455 1205.24L79.5705 1192.51L105.02 1217.96L168.627 1154.34L92.2955 1078.01L105.02 1065.28Z",
    fill: "#231F20"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 1090.73L92.2954 1103.46L41.4136 1154.36L66.8454 1179.79L54.1386 1192.51L15.9636 1154.34L79.5704 1090.73Z",
    fill: "#00A44F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 1065.28L395.368 1154.34L306.312 1243.4L268.155 1205.24L280.862 1192.51L306.312 1217.96L369.918 1154.34L293.587 1078.01L306.312 1065.28Z",
    fill: "#231F20"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 1090.73L293.587 1103.46L242.705 1154.36L268.155 1179.79L255.43 1192.51L217.255 1154.34L280.862 1090.73Z",
    fill: "#00A44F"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 1065.28L596.66 1154.34L507.603 1243.4L469.446 1205.24L482.171 1192.51L507.603 1217.96L571.228 1154.34L494.878 1078.01L507.603 1065.28Z",
    fill: "#231F20"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 1090.73L494.896 1103.46L443.996 1154.36L469.446 1179.79L456.721 1192.51L418.546 1154.34L482.171 1090.73Z",
    fill: "#00A44F"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 1065.28L797.969 1154.34L708.913 1243.4L670.738 1205.24L683.463 1192.51L708.894 1217.96L772.519 1154.34L696.188 1078.01L708.913 1065.28Z",
    fill: "#231F20"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 1090.73L696.188 1103.46L645.288 1154.36L670.738 1179.79L658.013 1192.51L619.856 1154.34L683.463 1090.73Z",
    fill: "#00A44F"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 1065.28L999.261 1154.34L910.204 1243.4L872.029 1205.24L884.754 1192.51L910.204 1217.96L973.811 1154.34L897.479 1078.01L910.204 1065.28Z",
    fill: "#231F20"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 1090.73L897.479 1103.46L846.579 1154.36L872.029 1179.79L859.304 1192.51L821.147 1154.34L884.754 1090.73Z",
    fill: "#00A44F"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 1065.28L1200.55 1154.34L1111.5 1243.4L1073.32 1205.24L1086.05 1192.51L1111.5 1217.96L1175.1 1154.34L1098.77 1078.01L1111.5 1065.28Z",
    fill: "#231F20"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 1090.73L1098.77 1103.46L1047.89 1154.36L1073.32 1179.79L1060.61 1192.51L1022.44 1154.34L1086.05 1090.73Z",
    fill: "#00A44F"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 1065.28L1401.84 1154.34L1312.79 1243.4L1274.63 1205.24L1287.34 1192.51L1312.79 1217.96L1376.39 1154.34L1300.06 1078.01L1312.79 1065.28Z",
    fill: "#231F20"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 1090.73L1300.06 1103.46L1249.18 1154.36L1274.63 1179.79L1261.9 1192.51L1223.73 1154.34L1287.34 1090.73Z",
    fill: "#00A44F"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 1065.28L1603.13 1154.34L1514.08 1243.4L1475.92 1205.24L1488.65 1192.51L1514.08 1217.96L1577.7 1154.34L1501.35 1078.01L1514.08 1065.28Z",
    fill: "#231F20"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 1090.73L1501.37 1103.46L1450.47 1154.36L1475.92 1179.79L1463.2 1192.51L1425.02 1154.34L1488.65 1090.73Z",
    fill: "#00A44F"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 1065.28L1804.44 1154.34L1715.39 1243.4L1677.21 1205.24L1689.94 1192.51L1715.39 1217.96L1778.99 1154.34L1702.66 1078.01L1715.39 1065.28Z",
    fill: "#231F20"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 1090.73L1702.66 1103.46L1651.76 1154.36L1677.21 1179.79L1664.49 1192.51L1626.33 1154.34L1689.94 1090.73Z",
    fill: "#00A44F"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 1065.28L2005.74 1154.34L1916.68 1243.4L1878.5 1205.24L1891.23 1192.51L1916.68 1217.96L1980.29 1154.34L1903.95 1078.01L1916.68 1065.28Z",
    fill: "#231F20"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 1090.73L1903.95 1103.46L1853.05 1154.36L1878.5 1179.79L1865.78 1192.51L1827.62 1154.34L1891.23 1090.73Z",
    fill: "#00A44F"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 1172.48L92.1135 1261.54L3.05672 1350.6L-35.1001 1312.42L-22.3751 1299.7L3.05672 1325.15L66.6817 1261.54L-9.6501 1185.19L3.05672 1172.48Z",
    fill: "#231F20"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 1172.48L293.423 1261.54L204.366 1350.6L166.191 1312.42L178.916 1299.7L204.366 1325.15L267.973 1261.54L191.641 1185.19L204.366 1172.48Z",
    fill: "#231F20"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1197.91L191.641 1210.64L140.741 1261.54L166.191 1286.97L153.466 1299.7L115.31 1261.54L178.916 1197.91Z",
    fill: "#00A44F"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 1172.48L494.714 1261.54L405.658 1350.6L367.483 1312.42L380.208 1299.7L405.658 1325.15L469.264 1261.54L392.933 1185.19L405.658 1172.48Z",
    fill: "#231F20"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1197.91L392.933 1210.64L342.051 1261.54L367.483 1286.97L354.758 1299.7L316.601 1261.54L380.208 1197.91Z",
    fill: "#00A44F"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 1172.48L696.006 1261.54L606.949 1350.6L568.774 1312.42L581.499 1299.7L606.949 1325.15L670.556 1261.54L594.224 1185.19L606.949 1172.48Z",
    fill: "#231F20"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1197.91L594.224 1210.64L543.342 1261.54L568.774 1286.97L556.067 1299.7L517.892 1261.54L581.499 1197.91Z",
    fill: "#00A44F"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 1172.48L897.297 1261.54L808.241 1350.6L770.084 1312.42L782.791 1299.7L808.241 1325.15L871.847 1261.54L795.516 1185.19L808.241 1172.48Z",
    fill: "#231F20"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1197.91L795.515 1210.64L744.634 1261.54L770.084 1286.97L757.359 1299.7L719.184 1261.54L782.809 1197.91Z",
    fill: "#00A44F"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 1172.48L1098.61 1261.54L1009.53 1350.6L971.375 1312.42L984.1 1299.7L1009.53 1325.15L1073.16 1261.54L996.825 1185.19L1009.53 1172.48Z",
    fill: "#231F20"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1197.91L996.825 1210.64L945.925 1261.54L971.375 1286.97L958.65 1299.7L920.475 1261.54L984.1 1197.91Z",
    fill: "#00A44F"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 1172.48L1299.9 1261.54L1210.84 1350.6L1172.67 1312.42L1185.39 1299.7L1210.84 1325.15L1274.45 1261.54L1198.12 1185.19L1210.84 1172.48Z",
    fill: "#231F20"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1197.91L1198.12 1210.64L1147.22 1261.54L1172.67 1286.97L1159.94 1299.7L1121.78 1261.54L1185.39 1197.91Z",
    fill: "#00A44F"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 1172.48L1501.19 1261.54L1412.13 1350.6L1373.96 1312.42L1386.68 1299.7L1412.13 1325.15L1475.74 1261.54L1399.41 1185.19L1412.13 1172.48Z",
    fill: "#231F20"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1197.91L1399.41 1210.64L1348.53 1261.54L1373.96 1286.97L1361.23 1299.7L1323.08 1261.54L1386.68 1197.91Z",
    fill: "#00A44F"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 1172.48L1702.48 1261.54L1613.42 1350.6L1575.25 1312.42L1587.97 1299.7L1613.42 1325.15L1677.03 1261.54L1600.7 1185.19L1613.42 1172.48Z",
    fill: "#231F20"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1197.91L1600.7 1210.64L1549.82 1261.54L1575.25 1286.97L1562.54 1299.7L1524.37 1261.54L1587.97 1197.91Z",
    fill: "#00A44F"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 1172.48L1903.77 1261.54L1814.71 1350.6L1776.56 1312.42L1789.26 1299.7L1814.71 1325.15L1878.34 1261.54L1801.99 1185.19L1814.71 1172.48Z",
    fill: "#231F20"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1197.91L1801.99 1210.64L1751.11 1261.54L1776.56 1286.97L1763.83 1299.7L1725.66 1261.54L1789.28 1197.91Z",
    fill: "#00A44F"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 1278.35L194.077 1367.41L105.02 1456.47L66.8455 1418.29L79.5705 1405.57L105.02 1431.02L168.627 1367.41L92.2955 1291.08L105.02 1278.35Z",
    fill: "#231F20"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 1303.79L92.2954 1316.51L41.4136 1367.41L66.8454 1392.86L54.1386 1405.57L15.9636 1367.41L79.5704 1303.79Z",
    fill: "#00A44F"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 1278.35L395.368 1367.41L306.312 1456.47L268.155 1418.29L280.862 1405.57L306.312 1431.02L369.918 1367.41L293.587 1291.08L306.312 1278.35Z",
    fill: "#231F20"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 1303.79L293.587 1316.51L242.705 1367.41L268.155 1392.86L255.43 1405.57L217.255 1367.41L280.862 1303.79Z",
    fill: "#00A44F"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 1278.35L596.66 1367.41L507.603 1456.47L469.446 1418.29L482.171 1405.57L507.603 1431.02L571.228 1367.41L494.878 1291.08L507.603 1278.35Z",
    fill: "#231F20"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 1303.79L494.896 1316.51L443.996 1367.41L469.446 1392.86L456.721 1405.57L418.546 1367.41L482.171 1303.79Z",
    fill: "#00A44F"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 1278.35L797.969 1367.41L708.913 1456.47L670.738 1418.29L683.463 1405.57L708.894 1431.02L772.519 1367.41L696.188 1291.08L708.913 1278.35Z",
    fill: "#231F20"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 1303.79L696.188 1316.51L645.288 1367.41L670.738 1392.86L658.013 1405.57L619.856 1367.41L683.463 1303.79Z",
    fill: "#00A44F"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 1278.35L999.261 1367.41L910.204 1456.47L872.029 1418.29L884.754 1405.57L910.204 1431.02L973.811 1367.41L897.479 1291.08L910.204 1278.35Z",
    fill: "#231F20"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 1303.79L897.479 1316.51L846.579 1367.41L872.029 1392.86L859.304 1405.57L821.147 1367.41L884.754 1303.79Z",
    fill: "#00A44F"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 1278.35L1200.55 1367.41L1111.5 1456.47L1073.32 1418.29L1086.05 1405.57L1111.5 1431.02L1175.1 1367.41L1098.77 1291.08L1111.5 1278.35Z",
    fill: "#231F20"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 1303.79L1098.77 1316.51L1047.89 1367.41L1073.32 1392.86L1060.61 1405.57L1022.44 1367.41L1086.05 1303.79Z",
    fill: "#00A44F"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 1278.35L1401.84 1367.41L1312.79 1456.47L1274.63 1418.29L1287.34 1405.57L1312.79 1431.02L1376.39 1367.41L1300.06 1291.08L1312.79 1278.35Z",
    fill: "#231F20"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 1303.79L1300.06 1316.51L1249.18 1367.41L1274.63 1392.86L1261.9 1405.57L1223.73 1367.41L1287.34 1303.79Z",
    fill: "#00A44F"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 1278.35L1603.13 1367.41L1514.08 1456.47L1475.92 1418.29L1488.65 1405.57L1514.08 1431.02L1577.7 1367.41L1501.35 1291.08L1514.08 1278.35Z",
    fill: "#231F20"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 1303.79L1501.37 1316.51L1450.47 1367.41L1475.92 1392.86L1463.2 1405.57L1425.02 1367.41L1488.65 1303.79Z",
    fill: "#00A44F"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 1278.35L1804.44 1367.41L1715.39 1456.47L1677.21 1418.29L1689.94 1405.57L1715.39 1431.02L1778.99 1367.41L1702.66 1291.08L1715.39 1278.35Z",
    fill: "#231F20"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 1303.79L1702.66 1316.51L1651.76 1367.41L1677.21 1392.86L1664.49 1405.57L1626.33 1367.41L1689.94 1303.79Z",
    fill: "#00A44F"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 1278.35L2005.74 1367.41L1916.68 1456.47L1878.5 1418.29L1891.23 1405.57L1916.68 1431.02L1980.29 1367.41L1903.95 1291.08L1916.68 1278.35Z",
    fill: "#231F20"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 1303.79L1903.95 1316.51L1853.05 1367.41L1878.5 1392.86L1865.78 1405.57L1827.62 1367.41L1891.23 1303.79Z",
    fill: "#00A44F"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 1385.53L92.1135 1474.59L3.05672 1563.65L-35.1001 1525.47L-22.3751 1512.77L3.05672 1538.2L66.6817 1474.59L-9.6501 1398.26L3.05672 1385.53Z",
    fill: "#231F20"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 1385.53L293.423 1474.59L204.366 1563.65L166.191 1525.47L178.916 1512.77L204.366 1538.2L267.973 1474.59L191.641 1398.26L204.366 1385.53Z",
    fill: "#231F20"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1410.98L191.641 1423.69L140.741 1474.59L166.191 1500.04L153.466 1512.77L115.31 1474.59L178.916 1410.98Z",
    fill: "#00A44F"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 1385.53L494.714 1474.59L405.658 1563.65L367.483 1525.47L380.208 1512.77L405.658 1538.2L469.264 1474.59L392.933 1398.26L405.658 1385.53Z",
    fill: "#231F20"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1410.98L392.933 1423.69L342.051 1474.59L367.483 1500.04L354.758 1512.77L316.601 1474.59L380.208 1410.98Z",
    fill: "#00A44F"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 1385.53L696.006 1474.59L606.949 1563.65L568.774 1525.47L581.499 1512.77L606.949 1538.2L670.556 1474.59L594.224 1398.26L606.949 1385.53Z",
    fill: "#231F20"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1410.98L594.224 1423.69L543.342 1474.59L568.774 1500.04L556.067 1512.77L517.892 1474.59L581.499 1410.98Z",
    fill: "#00A44F"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 1385.53L897.297 1474.59L808.241 1563.65L770.084 1525.47L782.791 1512.77L808.241 1538.2L871.847 1474.59L795.516 1398.26L808.241 1385.53Z",
    fill: "#231F20"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1410.98L795.515 1423.69L744.634 1474.59L770.084 1500.04L757.359 1512.77L719.184 1474.59L782.809 1410.98Z",
    fill: "#00A44F"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 1385.53L1098.61 1474.59L1009.53 1563.65L971.375 1525.47L984.1 1512.77L1009.53 1538.2L1073.16 1474.59L996.825 1398.26L1009.53 1385.53Z",
    fill: "#231F20"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1410.98L996.825 1423.69L945.925 1474.59L971.375 1500.04L958.65 1512.77L920.475 1474.59L984.1 1410.98Z",
    fill: "#00A44F"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 1385.53L1299.9 1474.59L1210.84 1563.65L1172.67 1525.47L1185.39 1512.77L1210.84 1538.2L1274.45 1474.59L1198.12 1398.26L1210.84 1385.53Z",
    fill: "#231F20"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1410.98L1198.12 1423.69L1147.22 1474.59L1172.67 1500.04L1159.94 1512.77L1121.78 1474.59L1185.39 1410.98Z",
    fill: "#00A44F"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 1385.53L1501.19 1474.59L1412.13 1563.65L1373.96 1525.47L1386.68 1512.77L1412.13 1538.2L1475.74 1474.59L1399.41 1398.26L1412.13 1385.53Z",
    fill: "#231F20"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1410.98L1399.41 1423.69L1348.53 1474.59L1373.96 1500.04L1361.23 1512.77L1323.08 1474.59L1386.68 1410.98Z",
    fill: "#00A44F"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 1385.53L1702.48 1474.59L1613.42 1563.65L1575.25 1525.47L1587.97 1512.77L1613.42 1538.2L1677.03 1474.59L1600.7 1398.26L1613.42 1385.53Z",
    fill: "#231F20"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1410.98L1600.7 1423.69L1549.82 1474.59L1575.25 1500.04L1562.54 1512.77L1524.37 1474.59L1587.97 1410.98Z",
    fill: "#00A44F"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 1385.53L1903.77 1474.59L1814.71 1563.65L1776.56 1525.47L1789.26 1512.77L1814.71 1538.2L1878.34 1474.59L1801.99 1398.26L1814.71 1385.53Z",
    fill: "#231F20"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1410.98L1801.99 1423.69L1751.11 1474.59L1776.56 1500.04L1763.83 1512.77L1725.66 1474.59L1789.28 1410.98Z",
    fill: "#00A44F"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M105.02 1491.41L194.077 1580.46L105.02 1669.52L66.8455 1631.36L79.5705 1618.64L105.02 1644.07L168.627 1580.46L92.2955 1504.13L105.02 1491.41Z",
    fill: "#231F20"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5704 1516.86L92.2954 1529.58L41.4136 1580.46L66.8454 1605.91L54.1386 1618.64L15.9636 1580.46L79.5704 1516.86Z",
    fill: "#00A44F"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M306.312 1491.41L395.368 1580.46L306.312 1669.52L268.155 1631.36L280.862 1618.64L306.312 1644.07L369.918 1580.46L293.587 1504.13L306.312 1491.41Z",
    fill: "#231F20"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M280.862 1516.86L293.587 1529.58L242.705 1580.46L268.155 1605.91L255.43 1618.64L217.255 1580.46L280.862 1516.86Z",
    fill: "#00A44F"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M507.603 1491.41L596.66 1580.46L507.603 1669.52L469.446 1631.36L482.171 1618.64L507.603 1644.07L571.228 1580.46L494.878 1504.13L507.603 1491.41Z",
    fill: "#231F20"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M482.171 1516.86L494.896 1529.58L443.996 1580.46L469.446 1605.91L456.721 1618.64L418.546 1580.46L482.171 1516.86Z",
    fill: "#00A44F"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M708.913 1491.41L797.969 1580.46L708.913 1669.52L670.738 1631.36L683.463 1618.64L708.894 1644.07L772.519 1580.46L696.188 1504.13L708.913 1491.41Z",
    fill: "#231F20"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M683.463 1516.86L696.188 1529.58L645.288 1580.46L670.738 1605.91L658.013 1618.64L619.856 1580.46L683.463 1516.86Z",
    fill: "#00A44F"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M910.204 1491.41L999.261 1580.46L910.204 1669.52L872.029 1631.36L884.754 1618.64L910.204 1644.07L973.811 1580.46L897.479 1504.13L910.204 1491.41Z",
    fill: "#231F20"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M884.754 1516.86L897.479 1529.58L846.579 1580.46L872.029 1605.91L859.304 1618.64L821.147 1580.46L884.754 1516.86Z",
    fill: "#00A44F"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.5 1491.41L1200.55 1580.46L1111.5 1669.52L1073.32 1631.36L1086.05 1618.64L1111.5 1644.07L1175.1 1580.46L1098.77 1504.13L1111.5 1491.41Z",
    fill: "#231F20"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1086.05 1516.86L1098.77 1529.58L1047.89 1580.46L1073.32 1605.91L1060.61 1618.64L1022.44 1580.46L1086.05 1516.86Z",
    fill: "#00A44F"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1312.79 1491.41L1401.84 1580.46L1312.79 1669.52L1274.63 1631.36L1287.34 1618.64L1312.79 1644.07L1376.39 1580.46L1300.06 1504.13L1312.79 1491.41Z",
    fill: "#231F20"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1287.34 1516.86L1300.06 1529.58L1249.18 1580.46L1274.63 1605.91L1261.9 1618.64L1223.73 1580.46L1287.34 1516.86Z",
    fill: "#00A44F"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.08 1491.41L1603.13 1580.46L1514.08 1669.52L1475.92 1631.36L1488.65 1618.64L1514.08 1644.07L1577.7 1580.46L1501.35 1504.13L1514.08 1491.41Z",
    fill: "#231F20"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.65 1516.86L1501.37 1529.58L1450.47 1580.46L1475.92 1605.91L1463.2 1618.64L1425.02 1580.46L1488.65 1516.86Z",
    fill: "#00A44F"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M1715.39 1491.41L1804.44 1580.46L1715.39 1669.52L1677.21 1631.36L1689.94 1618.64L1715.39 1644.07L1778.99 1580.46L1702.66 1504.13L1715.39 1491.41Z",
    fill: "#231F20"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1689.94 1516.86L1702.66 1529.58L1651.76 1580.46L1677.21 1605.91L1664.49 1618.64L1626.33 1580.46L1689.94 1516.86Z",
    fill: "#00A44F"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1916.68 1491.41L2005.74 1580.46L1916.68 1669.52L1878.5 1631.36L1891.23 1618.64L1916.68 1644.07L1980.29 1580.46L1903.95 1504.13L1916.68 1491.41Z",
    fill: "#231F20"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1891.23 1516.86L1903.95 1529.58L1853.05 1580.46L1878.5 1605.91L1865.78 1618.64L1827.62 1580.46L1891.23 1516.86Z",
    fill: "#00A44F"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M3.05672 1598.59L92.1135 1687.64L3.05672 1776.7L-35.1001 1738.54L-22.3751 1725.82L3.05672 1751.27L66.6817 1687.64L-9.6501 1611.31L3.05672 1598.59Z",
    fill: "#231F20"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M204.366 1598.59L293.423 1687.64L204.366 1776.7L166.191 1738.54L178.916 1725.82L204.366 1751.27L267.973 1687.64L191.641 1611.31L204.366 1598.59Z",
    fill: "#231F20"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M178.916 1624.04L191.641 1636.76L140.741 1687.64L166.191 1713.09L153.466 1725.82L115.31 1687.64L178.916 1624.04Z",
    fill: "#00A44F"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M405.658 1598.59L494.714 1687.64L405.658 1776.7L367.483 1738.54L380.208 1725.82L405.658 1751.27L469.264 1687.64L392.933 1611.31L405.658 1598.59Z",
    fill: "#231F20"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M380.208 1624.04L392.933 1636.76L342.051 1687.64L367.483 1713.09L354.758 1725.82L316.601 1687.64L380.208 1624.04Z",
    fill: "#00A44F"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M606.949 1598.59L696.006 1687.64L606.949 1776.7L568.774 1738.54L581.499 1725.82L606.949 1751.27L670.556 1687.64L594.224 1611.31L606.949 1598.59Z",
    fill: "#231F20"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M581.499 1624.04L594.224 1636.76L543.342 1687.64L568.774 1713.09L556.067 1725.82L517.892 1687.64L581.499 1624.04Z",
    fill: "#00A44F"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M808.241 1598.59L897.297 1687.64L808.241 1776.7L770.084 1738.54L782.791 1725.82L808.241 1751.27L871.847 1687.64L795.516 1611.31L808.241 1598.59Z",
    fill: "#231F20"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M782.809 1624.04L795.515 1636.76L744.634 1687.64L770.084 1713.09L757.359 1725.82L719.184 1687.64L782.809 1624.04Z",
    fill: "#00A44F"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1009.53 1598.59L1098.61 1687.64L1009.53 1776.7L971.375 1738.54L984.1 1725.82L1009.53 1751.27L1073.16 1687.64L996.825 1611.31L1009.53 1598.59Z",
    fill: "#231F20"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M984.1 1624.04L996.825 1636.76L945.925 1687.64L971.375 1713.09L958.65 1725.82L920.475 1687.64L984.1 1624.04Z",
    fill: "#00A44F"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.84 1598.59L1299.9 1687.64L1210.84 1776.7L1172.67 1738.54L1185.39 1725.82L1210.84 1751.27L1274.45 1687.64L1198.12 1611.31L1210.84 1598.59Z",
    fill: "#231F20"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1185.39 1624.04L1198.12 1636.76L1147.22 1687.64L1172.67 1713.09L1159.94 1725.82L1121.78 1687.64L1185.39 1624.04Z",
    fill: "#00A44F"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.13 1598.59L1501.19 1687.64L1412.13 1776.7L1373.96 1738.54L1386.68 1725.82L1412.13 1751.27L1475.74 1687.64L1399.41 1611.31L1412.13 1598.59Z",
    fill: "#231F20"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1386.68 1624.04L1399.41 1636.76L1348.53 1687.64L1373.96 1713.09L1361.23 1725.82L1323.08 1687.64L1386.68 1624.04Z",
    fill: "#00A44F"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M1613.42 1598.59L1702.48 1687.64L1613.42 1776.7L1575.25 1738.54L1587.97 1725.82L1613.42 1751.27L1677.03 1687.64L1600.7 1611.31L1613.42 1598.59Z",
    fill: "#231F20"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.97 1624.04L1600.7 1636.76L1549.82 1687.64L1575.25 1713.09L1562.54 1725.82L1524.37 1687.64L1587.97 1624.04Z",
    fill: "#00A44F"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M1814.71 1598.59L1903.77 1687.64L1814.71 1776.7L1776.56 1738.54L1789.26 1725.82L1814.71 1751.27L1878.34 1687.64L1801.99 1611.31L1814.71 1598.59Z",
    fill: "#231F20"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M1789.28 1624.04L1801.99 1636.76L1751.11 1687.64L1776.56 1713.09L1763.83 1725.82L1725.66 1687.64L1789.28 1624.04Z",
    fill: "#00A44F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackGroundOfSectionTwo1);
export default __webpack_public_path__ + "static/media/BackGroundOfSectionTwo1.5a9f6da76b7a7242bd86d3e6a759f488.svg";
export { ForwardRef as ReactComponent };